import { render, staticRenderFns } from "./SendingRideReceipts.vue?vue&type=template&id=777f8d10&scoped=true&"
import script from "./SendingRideReceipts.vue?vue&type=script&lang=js&"
export * from "./SendingRideReceipts.vue?vue&type=script&lang=js&"
import style0 from "./SendingRideReceipts.vue?vue&type=style&index=0&id=777f8d10&lang=scss&scoped=true&"
import style1 from "./SendingRideReceipts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777f8d10",
  null
  
)

export default component.exports